import { parse as gcParse } from '@greycat/lang';
var GreyCatParser = /** @class */ (function () {
    function GreyCatParser() {
    }
    GreyCatParser.prototype.parse = function (doc) {
        return gcParse(doc.getText());
    };
    return GreyCatParser;
}());
export default GreyCatParser;
//# sourceMappingURL=gc-parser.js.map